import { render } from "./App.vue?vue&type=template&id=f1dc0dfa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f1dc0dfa&lang=css"

import exportComponent from "/Users/mike/code/breathe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__